// extracted by mini-css-extract-plugin
export default {"section_quiz":"Quiz_section_quiz__HEElJ","container":"Quiz_container__uC3MS","category":"Quiz_category__DHbqv","questions":"Quiz_questions__WlXTm","span":"Quiz_span__2EX15"};